import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceHeadinfo = ({ blok }) => (
  <div className="wrap" {...storyblokEditable(blok)}>
    <h2 className="text-3xl merriweather">{blok.headline}</h2>
    <p>{blok.infotext}</p>
  </div>
);

export default ServiceHeadinfo;
